import React from 'react'
import BrowseAllRewards from "../../../../styles/img/browse-all-rewards.png"
import { UiButtonPrimary } from "../../components/form/UiButton"

export default function UiBrowseAllRewards(props) {
    

    return (
        <>
            <div className='sb-browse-rewards'>
                <div className='sb-browse-rewards__left-col'>
                    <img src={BrowseAllRewards} />
                </div>
                <div className='sb-browse-rewards__right-col'>
                    <h3>Browse All Rewards</h3>
                    <p>laboris nisi ut aliquip ex ea commodo consequat, laboris nisi ut aliquip ex ea commodo consequat</p>
                    <UiButtonPrimary btnName="Discover Now" size="70"/>
                </div>
            </div>
            
        </>
    )
}
